import React from 'react'
import { DropdownItem } from 'reactstrap'
import { BusinessTypeWithCategory } from '../../../types'

interface MCCDropdownItemProps {
  businessType: BusinessTypeWithCategory
  onSelect: (
    businessType: BusinessTypeWithCategory,
    categoryName: string,
  ) => void
}

const MCCDropdownItem: React.FC<MCCDropdownItemProps> = ({
  businessType,
  onSelect,
}) => {
  return (
    <DropdownItem
      key={`${businessType.categoryName}-${businessType.mcc}-${businessType.name}`}
      onClick={() => onSelect(businessType, businessType.categoryName)}
      className="py-2"
    >
      <div>
        <div className="fw-medium">{businessType.name}</div>
        <small className="text-muted">
          MCC: {businessType.mcc} • Category: {businessType.categoryName}
        </small>
      </div>
    </DropdownItem>
  )
}

export default MCCDropdownItem
